import { useEffect, useState } from "react";

interface WeatherData {
  temperatureC: number;
  feelsLikeC: number;
  humidity: number;
  rainfallMM: number;
  windSpeedKph: number;
}

interface WeatherHook {
  data: WeatherData | null;
  loading: boolean;
  error: string | null;
}

const API_KEY = "94488ccb442e4337ad735838231309";

export const useWeatherData = (lat: number, lon: number): WeatherHook => {
  const [data, setData] = useState<WeatherData | null>(null);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchWeather = async () => {
      try {
        setLoading(true);
        const res = await fetch(
          `https://api.weatherapi.com/v1/current.json?key=${API_KEY}&q=${lat},${lon}&aqi=no`
        );
        const json = await res.json();

        const extracted: WeatherData = {
          temperatureC: json.current.temp_c,
          feelsLikeC: json.current.feelslike_c,
          humidity: json.current.humidity,
          rainfallMM: json.current.precip_mm,
          windSpeedKph: json.current.wind_kph,
        };

        setData(extracted);
        setLoading(false);
      } catch (err) {
        setError("Failed to fetch weather data.");
        setLoading(false);
      }
    };

    if (lat && lon) fetchWeather();
  }, [lat, lon]);

  return { data, loading, error };
};
